/**
 * Generated runtime TestId mirror for frontend/src/pages/TypeValueDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypeValueDetailTestIds = {
  btnEditTranslations: "btn-edit-translations",
  btnSaveSettings: "btn-save-settings",
  cardTitleScopedAttributes: "card-title-scoped-attributes",
  cardTitleSettings: "card-title-settings",
  cardTitleTranslations: "card-title-translations",
  colDescription: "col-description",
  colDescriptionEdit: "col-description-edit",
  colLabel: "col-label",
  colLabelEdit: "col-label-edit",
  colLanguage: "col-language",
  colLanguageEdit: "col-language-edit",
  inputTemplate: "input-template",
  scopedAttributes: "scoped-attributes",
  stalePlaceholderWarning: "stale-placeholder-warning",
  typeValueDetail: "type-value-detail",
  typeValueDetailPage: "type-value-detail-page",
  chipDraggable: (attr_name: string) => `chip-draggable-${attr_name}`,
  chipDraggablePrefix: () => "chip-draggable-" as TestIdPrefix
} as const;
